var map = {
	"./activities@2x.png": 38665,
	"./calendar@2x.png": 40889,
	"./food@2x.png": 70679,
	"./list@2x.png": 55131,
	"./location@2x.png": 53904,
	"./message@2x.png": 83928,
	"./photos@2x.png": 90378,
	"./profile@2x.png": 63494,
	"./residence@2x.png": 4931,
	"./shopping@2x.png": 6923,
	"./survey@2x.png": 26945,
	"./websites@2x.png": 31161
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97797;